'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleItem = exports.Toggle = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  // padding: 40px;\n  overflow: hidden;\n\n  input {\n    position: absolute !important;\n    clip: rect(0, 0, 0, 0);\n    height: 1px;\n    width: 1px;\n    border: 0;\n    overflow: hidden;\n  }\n\n  label {\n    font-weight: 500;\n    line-height: 1em;\n    float: left;\n    display: inline-block;\n    width: 60px;\n    background-color: ', ';\n    color: ', ';\n    font-size: ', ';\n    text-align: center;\n    text-shadow: none;\n    padding: 15px 0;\n    border: 1px solid ', ';\n    transition: all 0.3s ease-in-out;\n    min-width: 160px;\n    cursor: pointer;\n  }\n\n  label:hover {\n    cursor: pointer;\n  }\n\n  input:checked:not(:disabled) + label {\n    background-color: ', ';\n    box-shadow: ', ';\n    color: ', ';\n  }\n\n  input:disabled:checked + label {\n    background-color: ', ';\n    border-color: ', ';\n    color: ', ';\n    box-shadow: ', ';\n  }\n\n  input:disabled + label {\n    background-color: ', ';\n    border-color: ', ';\n    color: ', ';\n    box-shadow: \'\';\n  }\n\n  label:first-of-type {\n    border-radius: 4px 0 0 4px;\n  }\n\n  label:last-of-type {\n    border-radius: 0 4px 4px 0;\n  }\n'], ['\n  // padding: 40px;\n  overflow: hidden;\n\n  input {\n    position: absolute !important;\n    clip: rect(0, 0, 0, 0);\n    height: 1px;\n    width: 1px;\n    border: 0;\n    overflow: hidden;\n  }\n\n  label {\n    font-weight: 500;\n    line-height: 1em;\n    float: left;\n    display: inline-block;\n    width: 60px;\n    background-color: ', ';\n    color: ', ';\n    font-size: ', ';\n    text-align: center;\n    text-shadow: none;\n    padding: 15px 0;\n    border: 1px solid ', ';\n    transition: all 0.3s ease-in-out;\n    min-width: 160px;\n    cursor: pointer;\n  }\n\n  label:hover {\n    cursor: pointer;\n  }\n\n  input:checked:not(:disabled) + label {\n    background-color: ', ';\n    box-shadow: ', ';\n    color: ', ';\n  }\n\n  input:disabled:checked + label {\n    background-color: ', ';\n    border-color: ', ';\n    color: ', ';\n    box-shadow: ', ';\n  }\n\n  input:disabled + label {\n    background-color: ', ';\n    border-color: ', ';\n    color: ', ';\n    box-shadow: \'\';\n  }\n\n  label:first-of-type {\n    border-radius: 4px 0 0 4px;\n  }\n\n  label:last-of-type {\n    border-radius: 0 4px 4px 0;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  margin-bottom: 6px;\n'], ['\n  margin-bottom: 6px;\n']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash.uniqueid');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.div(_templateObject, function (_ref) {
  var theme = _ref.theme;
  return theme.color.white;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.color.primary;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.font.fontSizeXS;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.color.primary;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.color.primary;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.shadow;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.color.white;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.color.disabled;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.form.placeholderColor;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.form.placeholderColor;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.shadowInactive;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.color.disabled;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.form.placeholderColor;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.form.placeholderColor;
});

var Title = _styledComponents2.default.div(_templateObject2);

var Toggle = exports.Toggle = function (_React$PureComponent) {
  _inherits(Toggle, _React$PureComponent);

  function Toggle() {
    _classCallCheck(this, Toggle);

    return _possibleConstructorReturn(this, (Toggle.__proto__ || Object.getPrototypeOf(Toggle)).apply(this, arguments));
  }

  _createClass(Toggle, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          theme = _props.theme,
          name = _props.name,
          children = _props.children,
          onChange = _props.onChange,
          rest = _objectWithoutProperties(_props, ['theme', 'name', 'children', 'onChange']);

      var items = [];
      if (this.props.children) {
        items = this.props.children.map(function (currentVal) {
          return _react2.default.cloneElement(currentVal, _extends({
            name: name,
            onChange: onChange,
            key: (0, _lodash2.default)('toggle-key-')
          }, rest));
        });
      }
      return _react2.default.createElement(
        Wrapper,
        _extends({ theme: theme }, rest),
        items
      );
    }
  }]);

  return Toggle;
}(_react2.default.PureComponent);

Toggle.propTypes = {
  name: _propTypes2.default.string.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  children: _propTypes2.default.node.isRequired,
  disabled: _propTypes2.default.bool
};

Toggle.defaultProps = {
  name: null,
  disabled: false
};

var ToggleItem = exports.ToggleItem = function (_React$PureComponent2) {
  _inherits(ToggleItem, _React$PureComponent2);

  function ToggleItem() {
    _classCallCheck(this, ToggleItem);

    return _possibleConstructorReturn(this, (ToggleItem.__proto__ || Object.getPrototypeOf(ToggleItem)).apply(this, arguments));
  }

  _createClass(ToggleItem, [{
    key: 'render',
    value: function render() {
      var id = (0, _lodash2.default)('toggle-');

      var _props2 = this.props,
          theme = _props2.theme,
          name = _props2.name,
          label = _props2.label,
          selectedValue = _props2.selectedValue,
          onChange = _props2.onChange,
          rest = _objectWithoutProperties(_props2, ['theme', 'name', 'label', 'selectedValue', 'onChange']);

      console.log(rest);
      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement('input', _extends({
          type: 'radio',
          role: 'radio',
          name: name,
          id: id,
          onChange: onChange
        }, rest)),
        _react2.default.createElement(
          'label',
          { htmlFor: id },
          label
        )
      );
    }
  }]);

  return ToggleItem;
}(_react2.default.PureComponent);

ToggleItem.propTypes = {
  name: _propTypes2.default.string,
  label: _propTypes2.default.string,
  checked: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool
};

ToggleItem.defaultProps = {
  name: null,
  label: null,
  disabled: false
};
Toggle.__docgenInfo = [{
  'description': '',
  'displayName': 'Toggle',
  'methods': [],
  'props': {
    'name': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'null',
        'computed': false
      }
    },
    'onChange': {
      'type': {
        'name': 'func'
      },
      'required': true,
      'description': ''
    },
    'children': {
      'type': {
        'name': 'node'
      },
      'required': true,
      'description': ''
    },
    'disabled': {
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'false',
        'computed': false
      }
    }
  }
}, {
  'description': '',
  'displayName': 'ToggleItem',
  'methods': [],
  'props': {
    'name': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'null',
        'computed': false
      }
    },
    'label': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'null',
        'computed': false
      }
    },
    'checked': {
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': ''
    },
    'disabled': {
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'false',
        'computed': false
      }
    }
  }
}];

if (typeof STORYBOOK_REACT_CLASSES !== 'undefined') {
  STORYBOOK_REACT_CLASSES['src/Toggle/index.js'] = {
    name: 'Toggle',
    docgenInfo: Toggle.__docgenInfo,
    path: 'src/Toggle/index.js'
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/oxyrion-ui/lib/Toggle/index.js
// module id = 182
// module chunks = 1